import React, { useContext, useEffect, useState } from 'react'
import Dashboard from '../Dashboard/Dashboard';
import Layout from '../../Components/Layout/Layout';
// import { FailedPopup, getSessionStorage, WarningPopup } from '../../common/Utils/Utils';
// import { useNavigate } from 'react-router-dom';





function Home() {
    const [IsLoading, setIsLoading] = useState(false)
	return (
		<Layout loading={IsLoading}>
			<Dashboard />
		</Layout>

	)
}
export default Home